import React from "react";
import Warnings from "../../AddressPanel/Warnings";
import { WarningsContainer } from "./__styles__/Overview";
import Divider from "../../Common/Divider";
import { PropertyOverviewContextProvider } from "../../AddressPanel/PropertyOverview/PropertyOverviewContext";
import { PropertyOverviewSections } from "../../AddressPanel/PropertyOverview/PropertyOverviewSections";
import { GuestPropertyTabProps } from ".";

export const Overview = ({
  propertyId,
  latitude,
  longitude,
  propertyLabel,
}: GuestPropertyTabProps) => {
  return (
    <>
      <WarningsContainer>
        <Warnings
          propertyId={propertyId}
          loading={false}
          publicOnly={true}
          canEditWarnings={false}
          address={propertyLabel}
        />
      </WarningsContainer>
      <Divider />
      <PropertyOverviewContextProvider
        latitude={latitude}
        longitude={longitude}
      >
        <PropertyOverviewSections shouldShowRepLoss={false} />
      </PropertyOverviewContextProvider>
    </>
  );
};
